import { jsx as _jsx } from "preact/jsx-runtime";
export const StoreNameComponent = ({ storeName }) => {
    return (_jsx("div", Object.assign({ class: "notification notification__storename" }, { children: storeName }), void 0));
};
